import React, { Component } from "react";
import { Redirect } from 'react-router-dom';

import { fetchToimplus, fetchToProfile, formSubmit } from './../assets/utils'

const dummyAvatarLink = 'https://i.pinimg.com/originals/21/28/32/2128326592a3c1142de7d08966e70e98.jpg';
const dummyDescription = 'բարև ձեզ ես սենց ընենց ընենց ընենց ընենց ընենց ընենց ընենց ընենցընենց ընենց ընենց ընենց ընենց';

class Choose extends Component {
  state = {
    imPlusIsActive: false,
    userInfo: {
      email: '',      // Email       0
      categoryId: '', // CategoryId  1
      name: '',       // FirstName   2
      lastName: '',   // LastName    3
      phone: '',      // Phone       4
      suspentions: '',
      loading: false,
      isActive: false
    },
    webApiMe: {
      id: 'initial',
      schId: 'initial',
      uid: 'initial',
      classNumber: 'initial',
    },
    redirect: false,
  };
  isReal = !!this.props.teacher
  componentWillMount() {

    fetchToimplus()
      .then(resp => {
        this.setState({isActive: resp === 'active'})
         // window.location.href = 'https://www.imdproc.am/Account/ExtraGate?returnURL=/404';
      });

    fetchToProfile()
      .then(resp => this.setState({
        userInfo: resp,
      }));

    fetch('/webapi/me')
      .then(resp => resp.json())
      .then(resp => this.setState({
        webApiMe: resp,
      }))
      .catch(console.log);

  }

  handleInputChange = (event) => {
    const target = event.target;
    const name = target.name;

    this.setState({
      userInfo: {
        ...this.state.userInfo,
        [name]: target.value,
      }
    });
  };
  componentDidMount() {
    window.scrollTo(0, 0,);
  }

  onSubmit = event => {
    if (this.state.isActive || true) {
      //forumlating of data to send
      const data = Object.assign({}, this.state.userInfo, this.state.webApiMe);
      data.subject = this.props.subject;
      data.classNumber = this.props.classNumber;
      data.teacherId = this.props.teacher.id;
      data.teacherName = this.props.teacher.name;
      formSubmit(event, data, () => this.setState({
        redirect: true,
      }) );
    } else {
      window.location.href = 'https://www.imdproc.am/Account/ExtraGate?returnURL=/info/online-teacher';
    }
  };

    render() {
    return (
      //afeter Submit
      this.state.redirect ?
        <Redirect to={'https://imdproc.am'}/> :
        !this.props.teacher ? //if user fall in this page not from choos page redirect to mine page
          <Redirect to={'/'}/> :
          <div className='portfilio'>
            <div className="portf-info">
              <div className="row">
                <div className="col-sm-5">
                  <img className="t-img" src={ this.isReal ? this.props.teacher.imgLink : dummyAvatarLink} alt=""/>
                </div>
                <div className="col-sm-7">
                  <h2 >{ this.isReal ? this.props.teacher.name : "Maximilian Nezhni"}</h2>
                  <div className="point">
                    <img  src="https://imdproc-uploads-prod.s3.amazonaws.com/upload/contentpages/Asset2.png" alt=""/>
                    <div className="slug">
                      <span>{this.props.teacher.specialty + ' ունի ' + this.props.teacher.XP + ' տարվա աշխատանքային փորձ:'}</span>
                    </div>
                      </div>
                  <div className="point">
                    <img src="https://imdproc-uploads-prod.s3.amazonaws.com/upload/contentpages/Asset4.png" alt=""/>
                    <div className="slug">
                      <span>{this.props.teacher.school}</span>
                    </div>
                  </div>
                  <div className="point">
                    <img src="https://imdproc-uploads-prod.s3.amazonaws.com/upload/contentpages/asset5.png" alt=""/>
                    <div className="slug">{this.props.teacher.slug}</div>
                  </div>

                </div>
              </div>

              <div className="portf-description">
                <br/>
                <p className="text-center">{this.isReal ? this.props.teacher.description : dummyDescription}</p>

              </div>
            </div>
            <div className="portf-seporator">
              <h3 className="text-center">Դասընթացի ամսական արժեքն է {this.props.teacher.price} դրամ և ակտիվ Իմ+ բաժանորդագրություն</h3>
            </div>
            <div className="portf-form">
              <form id='form'>
                <div className="IP-right">
                  <label>Անուն</label>
                  <input className="input" id='name' name='name' onChange={this.handleInputChange} value={this.state.userInfo.name} type='text'/><br/>
                  <label>Էլփոստ</label>
                  <input className="input" id='email' name='email' onChange={this.handleInputChange} value={this.state.userInfo.email} type='email'/><br/>
                  <label>Հեռախոսահամար</label>
                  <input className="input" id='phone' name='phone' onChange={this.handleInputChange} value={this.state.userInfo.phone} type='tel'/><br/>
                </div>
                <div className="IP-left">
                  <label>Ազգանուն</label>
                  <input className="input" id='lastName' name='lastName' onChange={this.handleInputChange} value={this.state.userInfo.lastName} type='text'/><br/>
                  <label>Ձեր ակնկալիքները</label>
                  <textarea className="IP-textarea" id="suspentions" name="suspentions" onChange={this.handleInputChange} value={this.state.userInfo.suspentions} rows="4" cols="50">

                  </textarea>
                </div>




                <div className="IP-submit shadow-2" id='IP-submit'  onClick={this.onSubmit}>Հաստատել</div>
              </form>
            </div>
          </div>
    )
  }
}

export default Choose;
